import httpBase from "../utils/http.utils";
import {
  TENANT_GET_INFO,
  TENANT_LANGUAGE_LIST,
  TENANT_SETUP_CHECK,
  TENANT_TOOLS,
  TENANT_PRESET_DATA,
  TENANT_EDIT_INFO,
  TENANT_TUTORIAL,
  CUSTOM_TOOL_CREATE,
  CUSTOM_TOOL_UPDATE,
  CUSTOM_TOOL_DELETE,
  CUSTOM_TOOL_LIST,
  TENANT_MSG_TEMPLATE_GET,
  TENANT_MSG_TEMPLATE_UPDATE,
} from "../constants/url";

export const getTenantLanguageListApi = ({
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    try {
      const response = await httpBase().post(TENANT_LANGUAGE_LIST);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const getTenantToolsApi = ({
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    try {
      const response = await httpBase().get(TENANT_TOOLS);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const getTenantPresetDataApi = ({
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    try {
      const response = await httpBase().post(TENANT_PRESET_DATA, {});
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const getTenantSetupCheckApi = ({
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    try {
      const response = await httpBase().get(TENANT_SETUP_CHECK);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

// here

export const updateTenantTutorialApi = ({
  status,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    try {
      const response = await httpBase().patch(TENANT_TUTORIAL, {}, { params: { status } });
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const getBusinessInfoApi = ({
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    try {
      const response = await httpBase().get(TENANT_GET_INFO);
      successCallback(response?.data?.result || response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const editBusinessInfoApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    try {
      const response = await httpBase().post(TENANT_EDIT_INFO, params);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const createCustomToolApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    try {
      const response = await httpBase().post(CUSTOM_TOOL_CREATE, params);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const getCustomToolsApi = ({
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    try {
      const response = await httpBase().get(CUSTOM_TOOL_LIST);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const deleteCustomToolApi = ({
  toolId,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    try {
      const response = await httpBase().delete(`${CUSTOM_TOOL_DELETE}${toolId}`);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const updateCustomToolApi = ({
  toolId,
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    try {
      const response = await httpBase().put(`${CUSTOM_TOOL_UPDATE}${toolId}`, params);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const getMsgTemplatesApi = ({
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    try {
      const response = await httpBase().get(TENANT_MSG_TEMPLATE_GET);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const updateMsgTemplatesApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    try {
      const response = await httpBase().put(TENANT_MSG_TEMPLATE_UPDATE, params);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};